import { PricingTableHelper, getTotalDiscount, getTotalDiscountIsEmpty, getTotalTax, getTotalTaxIsEmpty, getTotalPriceValue, defaultSummaryValues, } from '@getaccept/editor-lib-new';
import { computed, defineComponent } from 'vue';
export default defineComponent({
    name: 'PricingTablePriceSummary',
    props: {
        summaryValues: {
            type: Object,
            default: () => (Object.assign({}, defaultSummaryValues)),
        },
        currencySettings: {
            type: Object,
            default: () => ({}),
        },
        isPreCalculated: { type: Boolean },
        sections: { type: Array, default: () => [] },
        fields: { type: Array, default: () => [] },
    },
    setup(props) {
        const summaryDiscountEnabled = computed(() => { var _a; return (_a = props.summaryValues.discount) === null || _a === void 0 ? void 0 : _a.enabled; });
        const summaryTaxEnabled = computed(() => { var _a; return (_a = props.summaryValues.tax) === null || _a === void 0 ? void 0 : _a.enabled; });
        const summaryPriceDisplayName = computed(() => { var _a; return ((_a = props.summaryValues.price) === null || _a === void 0 ? void 0 : _a.displayName) || ''; });
        const getTotalTaxValue = computed(() => {
            if (getTotalTaxIsEmpty(props.summaryValues)) {
                return '';
            }
            return getTotalTax(props.summaryValues, props.currencySettings, props.isPreCalculated, props.sections, props.fields);
        });
        const getTotalDiscountValue = computed(() => {
            if (getTotalDiscountIsEmpty(props.summaryValues)) {
                return '';
            }
            return getTotalDiscount(props.summaryValues, props.currencySettings, props.isPreCalculated, props.sections, props.fields);
        });
        return {
            getTotalTaxValue,
            getTotalDiscountValue,
            summaryDiscountEnabled,
            summaryTaxEnabled,
            summaryPriceDisplayName,
            currencyFormat: PricingTableHelper.currencyFormat,
            getTotalTaxIsEmpty,
            getTotalDiscountIsEmpty,
            getTotalPriceValue,
        };
    },
});
